import { cpFulfillmentVoucherLocs } from 'libs/clients/src/comptia/fulfillment-vouchers/fulfillment-voucher.locs';
import { cpSuspendGrantableCertsLocs } from 'libs/clients/src/comptia/manual-suspend-periods/components/cp-suspend-grantable-certs/cp-suspend-grantable-certs.locs';
import { cpCmUiModuleLocs } from 'libs/cm/ui/src/lib/cm-ui-module.locs';
import { enumLocs } from 'libs/core/localization/src/data/enums/enum.locs';
import { cpAchievementsModuleLocs } from 'libs/cp/feature/achievements/src/lib/cp-achievements.module.locs';
import { cpAuditLocs } from 'libs/cp/feature/audit/src/lib/audit-locs';
import { cpBenefitModuleLocs } from 'libs/cp/feature/benefits/src/lib/benefits.module.locs';
import { catalogsModuleLocs } from 'libs/cp/feature/catalogs/src/lib/catalogs.module.locs';
import { cpCertModuleLocs } from 'libs/cp/feature/certs/src/lib/certs.module.locs';
import { cpEcommerceHistoryLocs } from 'libs/cp/feature/ecommerce/src/lib/history/components/ecommerce-history/ecommerce-history.locs';
import { cpEcommerceStoreLocs } from 'libs/cp/feature/ecommerce/src/lib/storefront/components/storefront/storefront.locs';
import { creqProgramFeesLocs } from 'libs/cp/feature/history/src/lib/creqs/program-fees/components/program-fees/program-fees.locs';
import { cpHistoryModuleLocs } from 'libs/cp/feature/history/src/lib/history.module.locs';
import { homeModuleLocs } from 'libs/cp/feature/home/src/lib/home.module.locs';
import { cpLoginModuleLocs } from 'libs/cp/feature/login/src/lib/login.module.locs';
import { cpOtherAchievementFeatureLocs } from 'libs/cp/feature/other-achievements/src/lib/components/other-achievement-feature.locs';
import { cpPasswordResetFormLocs } from 'libs/cp/feature/profile/src/lib/my-information/forms/password-reset-form.locs';
import { cpProfileModuleLocs } from 'libs/cp/feature/profile/src/lib/profile.module.locs';
import { selfMergeRouteLocs } from 'libs/cp/feature/profile/src/lib/self-merge/self-merge-route.locs';
import { selfMergeModuleLocs } from 'libs/cp/feature/profile/src/lib/self-merge/self-merge.module.locs';
import { cpPublicModuleLocs } from 'libs/cp/feature/public/src/lib/public.module.locs';
import { cpSSOEgressModuleLocs } from 'libs/cp/feature/schedule/src/lib/modules/sso-egress/sso-egress.module.locs';
import { cpScheduleModuleLocs } from 'libs/cp/feature/schedule/src/lib/schedule.module.locs';
import { shareModuleLocs } from 'libs/cp/feature/share/src/lib/share.module.locs';
import { cpSSOAuthLocs } from 'libs/cp/feature/sso/src/lib/components/authorize/authorize.locs';
import { cpDataManagerLibLocs } from 'libs/cp/shared/data-management/src/cp-data-management.locs';
import { cpBannedLandingPageLocs } from 'libs/cp/shared/ui/src/lib/modules/components/banned-landing-page/banned-landing-page.locs';
import { appointmentCardLocs } from 'libs/cp/shared/ui/src/lib/modules/dashboard/components/appointment-card/apppointment-card.locs';
import { cpDashboardAppointmentLocs } from 'libs/cp/shared/ui/src/lib/modules/dashboard/components/appointments/apppointment.locs';
import { cpProfileAffiliationFormLocs } from 'libs/cp/ui/src/lib/components/requirement-forms/profile-affiliations/profile-affiliations.locs';
import { cpRequirementFormLocs } from 'libs/cp/ui/src/lib/components/requirement-forms/requirement-form.locs';
import { cpUIModuleLocs } from 'libs/cp/ui/src/lib/cp-ui-module.locs';
import { cpSharedProfileAffiliationFormLocs } from 'libs/feature/affiliation/src/components/candidate-affiliation-form/candidate-affiliation-form.cp-locs';
import { cpSharedPageLocs } from 'libs/shared/pages/src/library.locs';

export const preloadedCP = {};
export const allCP = {
	...cpBenefitModuleLocs,
	...catalogsModuleLocs,
	...cpAchievementsModuleLocs,
	...cpCertModuleLocs,
	...cpDataManagerLibLocs,
	...cpHistoryModuleLocs,
	...creqProgramFeesLocs,
	...cpLoginModuleLocs,
	...cpOtherAchievementFeatureLocs,
	...cpProfileAffiliationFormLocs,
	...cpPublicModuleLocs,
	...cpRequirementFormLocs,
	...cpSSOAuthLocs,
	...cpScheduleModuleLocs,
	...cpSharedPageLocs,
	...cpSharedProfileAffiliationFormLocs,
	...cpUIModuleLocs,
	...enumLocs,
	...homeModuleLocs,
	...cpProfileModuleLocs,
	...selfMergeModuleLocs,
	...selfMergeRouteLocs,
	...shareModuleLocs,
	...cpSSOEgressModuleLocs,
	...cpCmUiModuleLocs,
	...selfMergeModuleLocs,
	...selfMergeRouteLocs,
	...cpSSOAuthLocs,
	...appointmentCardLocs,
	...cpDashboardAppointmentLocs,
	...cpBannedLandingPageLocs,
	...cpEcommerceHistoryLocs,
	...cpEcommerceStoreLocs,
	...cpAuditLocs,
	...cpFulfillmentVoucherLocs,
	...cpSuspendGrantableCertsLocs,
	...cpPasswordResetFormLocs,
};
